import { useEffect, useMemo, useState } from '@wordpress/element';
import { getUrlBlog, obterIdPost, verificarGeradorIa } from './Auxiliares/auxiliaresArtigo';
import { useAction } from '@api/actions/action';
import { dispatch, useSelect } from '@wordpress/data';
import { useAdicionarArtigoMinimo } from '@api/controllers/artigo';
import { store } from '../redux/store';

export const useSalvarArtigoOpti = () => {
  const [artigoOpti, setArtigoOpti] = useState(null);
  const [payloadPronto, setPayloadPronto] = useState(false);
  const urlBlog = useMemo(() => getUrlBlog(), []);
  const foiGeradoPorIa = useMemo(() => verificarGeradorIa(), []);
  const idPost = useMemo(() => obterIdPost(), []);

  const {
    mutateAsync: buscarUsuarioOpti,
    data: usuario,
    isLoading: carregandoUsuario,
    isError: erroUsuario,
  } = useAction();

  const dataPublicacao = useSelect(select => select('core/editor').getEditedPostAttribute('date'));

  const {
    mutateAsync: adicionarArtigo,
    isLoading: salvandoArtigo,
    isError: erroAoSalvar,
  } = useAdicionarArtigoMinimo();

  useEffect(() => {
    buscarUsuarioOpti('obter_usuario_opti')
      .then(res => {
        localStorage.setItem('id_usuario_wp', res?.data?.idUsuarioWordpress);
        dispatch(store).setBlogIdOpti(parseInt(res?.data?.idUsuarioWordpress));
        dispatch(store).setUsuarioIdOpti(parseInt(res?.data?.idUsuarioOpti));
      })
      .catch(erro => {
        console.error('Erro ao buscar usuário:', erro);
      });
  }, [buscarUsuarioOpti]);

  const payload = useMemo(() => {
    if (!usuario?.data || !dataPublicacao) return null;

    return {
      idArtigoWp: idPost,
      idUsuarioWordpress: parseInt(usuario.data.idUsuarioWordpress),
      idUsuario: parseInt(usuario.data.idUsuarioOpti),
      url: urlBlog,
      dataPublicacao,
      geradoPorIa: foiGeradoPorIa,
    };
  }, [usuario, dataPublicacao, idPost, urlBlog, foiGeradoPorIa]);

  useEffect(() => {
    if (payload !== null && !payloadPronto) {
      setPayloadPronto(true);

      adicionarArtigo(payload)
        .then(res => {
          if (res?.data) {
            setArtigoOpti(res.data);
            localStorage.setItem('id_artigo_opti', res.data.id);
          }
        })
        .catch(erro => {
          console.error('Erro ao adicionar artigo:', erro);
        });
    }
  }, [payload, adicionarArtigo, payloadPronto]);

  return {
    artigoOpti,
    carregando: carregandoUsuario || salvandoArtigo,
    erro: erroUsuario || erroAoSalvar,
  };
};
